import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Link, Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
/**
 * The site-wide header
 */

export const NavItem: React.FC<React.PropsWithChildren> = (props) => {
    return <div className="rft_nav_item">{props.children}</div>;
};

export const NavLink: React.FC<React.PropsWithChildren<{ href: string }>> = (
    props
) => {
    return (
        <Link
            href={props.href}
            underline="none"
            sx={{
                textDecoration: "none",
                borderRadius: "0px",
                display: "block",
                height: "100%",
                width: "100%"
            }}
        >
            <Typography
                sx={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    letterSpacing: "0.1em"
                }}
            >
                {props.children}
            </Typography>
        </Link>
    );
};

export const SubNavLink: React.FC<React.PropsWithChildren<{ href: string }>> = (
    props
) => {
    return (
        <Link
            href={props.href}
            underline="none"
            sx={{
                textDecoration: "none",
                borderRadius: "0px",
                display: "block",
                height: "100%",
                width: "100%",
                padding: "8px 16px"
            }}
        >
            <Typography
                sx={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    letterSpacing: "0.1em"
                }}
            >
                {props.children}
            </Typography>
        </Link>
    );
};

export const NavMenu: React.FC<React.PropsWithChildren<NavMenuProps>> = (
    props
) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Link
                component="button"
                underline="none"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{
                    fontSize: "12px",
                    mx: "auto",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    textAlign: "center",
                    letterSpacing: "0.1em",
                    lineHeight: "1.5",
                    borderRadius: "0px",
                    display: "block",
                    height: "100%",
                    width: "100%"
                }}
            >
                <>
                    <span style={{ float: "right" }}>
                        {open ? (
                            <ExpandLess
                                sx={{ stroke: "#fff", strokeWidth: 1 }}
                            />
                        ) : (
                            <ExpandMore
                                sx={{ stroke: "#fff", strokeWidth: 1 }}
                            />
                        )}
                    </span>
                    <div>
                        {props.title.split(" ").map((t, i) => {
                            return (
                                <span key={`nav_menu_${t}_${i}`}>
                                    {t} <br />
                                </span>
                            );
                        })}
                    </div>
                </>
            </Link>
            <Menu
                id="nav-menu"
                // elevation={0}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className="rft_product_menu"
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                MenuListProps={{
                    "aria-labelledby": "basic-button"
                }}
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: 0
                    }
                }}
            >
                {props.items.map((item, i) => {
                    return (
                        <MenuItem
                            key={`nav_link_${item.title}_${i}`}
                            sx={{ padding: "0px", textAlign: "center" }}
                        >
                            <SubNavLink href={item.href}>
                                {item.title.split("\n").map((t) => {
                                    return (
                                        <span key={`nav_menu_link_${t}_${i}`}>
                                            {t} <br />
                                        </span>
                                    );
                                })}
                            </SubNavLink>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export interface NavMenuProps {
    title: string;
    items: iNavItem[];
}

export interface iNavItem {
    title: string;
    href: string;
}
